export default {
  session: [],
  consorcio: [],
  financiamento: [],
  trend: [],
  filter: [],
  leads: [],
  leadff: [],
};
